// constants
import { SideBarMenuActionTypes } from './constants';
import { MenuItemTypes as SideBarMenuDataType } from 'src/types/sideBarMenu';

export type SideBarMenuActionType = {
    type:
        | SideBarMenuActionTypes.API_RESPONSE_SUCCESS
        | SideBarMenuActionTypes.API_RESPONSE_ERROR
        | SideBarMenuActionTypes.GET_SIDE_BAR_MENU
        | SideBarMenuActionTypes.RESET
        | SideBarMenuActionTypes.RESET_SUCCESS
        | SideBarMenuActionTypes.RESET_ERROR;
    payload: {} | string;
};

// common success
export const sideBarMenuApiResponseSuccess = (
    actionType: string,
    data: SideBarMenuDataType[] | [],
    message: string,
    code: number,
    error: string | boolean,
    success: boolean
): SideBarMenuActionType => ({
    type: SideBarMenuActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data, message, code, error, success },
});
// common error
export const sideBarMenuApiResponseError = (
    actionType: string,
    data: SideBarMenuDataType | {},
    message: string,
    code: number,
    error: string | boolean,
    success: boolean
): SideBarMenuActionType => ({
    type: SideBarMenuActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, data, message, code, error, success },
});

export const getSideBarMenus = (params: any): SideBarMenuActionType => ({
    type: SideBarMenuActionTypes.GET_SIDE_BAR_MENU,
    payload: params,
});

export const resetSideBarMenu = (): SideBarMenuActionType => ({
    type: SideBarMenuActionTypes.RESET,
    payload: {},
});

export const resetSideBarMenuSuccess = (): SideBarMenuActionType => ({
    type: SideBarMenuActionTypes.RESET_SUCCESS,
    payload: {},
});
export const resetSideBarMenuError = (): SideBarMenuActionType => ({
    type: SideBarMenuActionTypes.RESET_ERROR,
    payload: {},
});
